import { useSelector } from "react-redux"
import { RootState } from "store"

export const useAuth = () => {
    return useSelector((state: RootState) => state.auth);
}

export const usePrivileges = () => {
    return useSelector((state: RootState) => state.auth.privileges);
}